<template>
  <div>
    <b-row>
      <b-col md="3">
        <v-select
          placeholder="Seleccione Categoria"
          :options="listCategorias"
          :clearable="false"
          style="width: 100%"
          @input="changeCategoria"
          class="select-size-sm"
          v-model="categoria"
        />
      </b-col>
      <b-col md="6">
        <div
          :ref="idElegido"
          style="border: 1px solid ;width:472px; height:346px; background-color:gray; position:relative"
        >
          <img id="divFondo" width="470px" height="344px" />

          <VueDragResize
            v-for="item in listObjetos"
            :key="item.id_carnet_nuevo"
            :w="item.width"
            :h="item.height"
            :x="item.left"
            :y="item.top"
            :minh="10"
            :isActive="item.isActive"
            :isDraggable="true"
            v-on:resizing="changePosition($event, item.id_carnet_usar)"
            v-on:dragging="changePosition($event, item.id_carnet_usar)"
            :parentLimitation="true"
            contentClass="box-shadow"
            :parentW="472"
            :parentH="346"
            @activated="onActivated(item.id_carnet_usar)"
            :aspectRatio="false"
          >
            <!-- <p>{{ width }} X {{ height }}</p> -->
            <!-- <div
          v-bind:style="{ fontSize: fontSize + 'px' }"
          id="ti"
          class="titulo"
        >
          {{ item.text }}
        </div> -->
            <div
              v-if="!item.isFoto"
              class="titulo"
              :style="{ fontSize: item.sizeText + 'px', color: item.color }"
            >
              <b v-if="item.leyenda">{{ item.leyendaText }}: </b>

              <span :class="[item.bold ? 'bold' : 'normal']">
                {{ item.text }}
              </span>
            </div>
            <div v-else>
              <img
                src="https://play-gol.com/optimiza/admin/img/default.jpg"
                width="106"
                height="152"
              />
            </div>
          </VueDragResize>
        </div>
        <b-form-group>
          <b-form-radio-group
            id="btn-radios-1"
            button-variant="outline-primary"
            v-model="tipoJugador"
            :options="optionsEstados"
            buttons
            name="radios-btn-default"
            class="mt-1 d-flex"
            @change="changeTipo"
          />
        </b-form-group>
        <b-row>
          <b-col md="10">
            <b-form-file
              v-model="file2"
              class="mt-1"
              @change="cambioFondo"
              placeholder="Seleccionar nuevo fondo"
            />
          </b-col>
          <b-col md="2" class="d-flex align-items-end">
            <b-button
              v-if="file2 != null"
              v-ripple.400="'rgba(40, 199, 111, 0.15)'"
              variant="flat-danger"
              class="btn-icon"
              @click="resetFotoCarnet"
            >
              <feather-icon icon="XIcon" />
            </b-button>
          </b-col>
        </b-row>

        <!-- <b-button
          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
          variant="outline-primary"
          size="sm"
        >
          <feather-icon icon="HomeIcon" class="mr-50" />
          <span class="align-middle">Cambiar Fondo</span>
        </b-button> -->
      </b-col>
      <b-col md="3">
        <b-row>
          <b-col md="5">
            <b-form-checkbox>
              Todo
            </b-form-checkbox>
          </b-col>
          <b-col md="3">
            <b-form-input size="sm" style="width:50px" type="number" />
          </b-col>
          <b-col md="3">
            <b-form-input type="color" size="sm" style="width:50px" />
          </b-col>
        </b-row>
        <b-row
          v-for="item in listObjetos"
          :key="item.id_carnet_mostrar"
          style="margin-top:4px"
          v-show="!item.isFoto"
        >
          <b-col md="5" class="d-flex align-items-center">
            <b-form-checkbox
              v-model="item.leyenda"
              :disabled="item.permite_leyenda ? false : true"
            >
              {{ item.leyendaText }}
            </b-form-checkbox>
          </b-col>
          <b-col md="3">
            <b-form-input
              v-model="item.sizeText"
              size="sm"
              style="width:50px"
              type="number"
            />
          </b-col>
          <b-col md="3">
            <b-form-input
              v-model="item.color"
              type="color"
              size="sm"
              style="width:50px"
            />
          </b-col>
        </b-row>
        <b-row class="mt-2 ">
          <b-col md="12" class="d-flex justify-content-center">
            <b-button
              @click="updateCarnet"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              size="sm"
            >
              Guardar
            </b-button>
          </b-col>
          <b-col md="12" class="mt-1 d-flex justify-content-center">
            <b-button
              @click="desactived"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              size="sm"
            >
              Limpiar
            </b-button>
          </b-col>
        </b-row>

        <!-- <b-form-checkbox v-model="selected" value="A">
          Apellidos
        </b-form-checkbox>
        <b-form-checkbox v-model="selected" value="A">
          Fecha Nacimiento
        </b-form-checkbox>
         <b-form-checkbox v-model="selected" value="A">
          C.I
        </b-form-checkbox>
         <b-form-checkbox v-model="selected" value="A">
          Club
        </b-form-checkbox>
        <b-form-checkbox v-model="selected" value="A">
          Categoria
        </b-form-checkbox>
        <b-form-checkbox v-model="selected" value="A">
          Numero
        </b-form-checkbox>
        <b-form-checkbox v-model="selected" value="A">
          Tipo jugador
        </b-form-checkbox> -->
        <!-- <b-form-input
          v-model="input"
          class="d-inline-block mr-1"
          placeholder="Buscar..."
          @keyup="cambiarTop"
        /> -->
      </b-col>
    </b-row>
    <!-- <img id="divFondo" src="" alt="" /> -->
  </div>
</template>
<script>
import vSelect from 'vue-select'
import {
  BRow,
  BCol,
  BFormInput,
  BFormCheckbox,
  BButton,
  // BButtonGroup,
  BFormRadioGroup,
  BFormGroup,
  BFormFile,
  // BFormRadio,
  //  xxx
} from 'bootstrap-vue'
import VueDragResize from 'vue-drag-resize'
import Ripple from 'vue-ripple-directive'
import { ref } from '@vue/composition-api'
import { URL, TIPOS_JUGADOR } from '../../utils/variables'
import apiCall from '../../utils/apiCall'

export default {
  components: {
    VueDragResize,
    BRow,
    BCol,
    vSelect,
    BFormInput,
    BFormCheckbox,
    BButton,
    BFormRadioGroup,
    BFormGroup,
    BFormFile,
    // BFormRadio,
    // BButtonGroup,
  },
  directives: {
    Ripple,
  },
  props: {
    listCategorias: Array,
  },
  setup() {
    const width = ref(300)
    const height = ref(100)
    const top = ref(10)
    const left = ref(10)
    const fontSize = ref(14)
    const entradaX = ref()
    const categoria = ref(null)
    const { getApi, postApi } = apiCall()
    const listObjetos = ref([])
    const input = ref(null)
    const idElegido = ref(0)
    const file2 = ref(null)
    const tipoJugador = ref('Novato')
    const optionsEstados = ref([])
    const fotografia = ref('')
    function cambioFondo(evt) {
      // console.log('cambio')
      const tgt = evt.target || window.event.srcElement
      const file = tgt.files[0]
      // console.log('tgt', tgt.files)
      // const ctx = document.getElementById('canvas').getContext('2d')
      // const img = new Image()
      // img.onload = function() {
      //   ctx.drawImage(img, 20, 20)
      // }
      // img.src = URL.createObjectURL(tgt.files[0])
      // const files = tgt.files
      // // alert(files[0].name);
      // const ar = files[0].name.split('.')
      // console.log(ar)
      // const files = file2.files[0]
      // console.log(file2, files)
      // const reader = new FileReader()
      // reader.readAsDataURL(file)
      const reader = new FileReader()
      reader.readAsBinaryString(file)
      // eslint-disable-next-line
      reader.onload = function() {
        // console.log(btoa(reader.result))
        fotografia.value = btoa(reader.result)
        document.getElementById('divFondo').src = `data:image/png;base64,${btoa(
          // eslint-disable-next-line
          reader.result
        )}`
      }
      // eslint-disable-next-line
      reader.onerror = function() {
        // console.log('there are some problems')
      }
    }
    function changeTipo() {
      // console.log(tipoJugador.value)
      file2.value = null
      fotografia.value = ''
      if (tipoJugador.value === TIPOS_JUGADOR.NOVATO) {
        document.getElementById('divFondo').src = categoria.value.carnet_novato
      } else if (tipoJugador.value === TIPOS_JUGADOR.JUVENIL) {
        document.getElementById('divFondo').src = categoria.value.carnet_juvenil
      } else if (tipoJugador.value === TIPOS_JUGADOR.CLASIFICADO) {
        document.getElementById('divFondo').src =
          categoria.value.carnet_clasificado
      }
    }
    function setearActualizadoUrl(url) {
      if (tipoJugador.value === TIPOS_JUGADOR.NOVATO) {
        categoria.value.carnet_novato = url
      } else if (tipoJugador.value === TIPOS_JUGADOR.JUVENIL) {
        categoria.value.carnet_juvenil = url
      } else if (tipoJugador.value === TIPOS_JUGADOR.CLASIFICADO) {
        categoria.value.carnet_clasificado = url
      }
    }
    function resetFotoCarnet() {
      file2.value = null
      fotografia.value = null
      changeTipo()
    }
    function cambiarTop(ev) {
      // const top = parseInt(ev.target.value)
      // console.log(ev.target.value)
      listObjetos.value[2].top = parseInt(ev.target.value, 10)
      listObjetos.value[2].key = Math.random(1000)
    }
    function resize(newRect) {
      width.value = newRect.width
      height.value = newRect.height
      top.value = newRect.top
      left.value = newRect.left
      // const ratio = width.value / height.value
      // const el = document.getElementById('ti')
      // const boxtxt = window
      //   .getComputedStyle(el, null)
      //   .getPropertyValue('font-size')
      // const valo = parseFloat(boxtxt)
      // console.log(valo, ratio)
      // fontSize.value = (valo * ratio) / 1000
      // console.log(fontSize.value)
    }
    function onActivated(id) {
      // console.log('actived')
      const found = listObjetos.value.find(
        // eslint-disable-next-line
        element => element.id_carnet_usar === id
      )
      // console.log(found)
      found.isActive = true
      // found.id_carnet_nuevo = Math.floor(Math.random() * 1000)
      idElegido.value = Math.floor(Math.random() * 10000)
    }
    function desactived() {
      // console.log('desactive')
      // const found = listObjetos.value.find(
      //   // eslint-disable-next-line
      //   element => element.id_carnet_nuevo === '5'
      // )
      // console.log(found)
      // found.isActive = true
      listObjetos.value.forEach(element => {
        // const rand = Math.floor(Math.random() * 1000)
        element.isActive = false
        // element.id_carnet_nuevo = rand
      })
      idElegido.value = Math.floor(Math.random() * 10000)
    }
    // const listObjetosComputed = computed(() => {
    //   console.log('cambio ar')
    //   // listObjetos.valueforEach(element => {
    //   //   element.key =
    //   // })
    //   return listObjetos.value
    // })

    function imprime() {
      // console.log(listObjetos.value)
      const rand = Math.floor(Math.random() * 10)
      // console.log(rand)
      listObjetos.value[rand].isActive = true
      listObjetos.value[rand].id_carnet_nuevo = Math.floor(Math.random() * 1000)
    }
    function entroEn(event) {
      // console.log('entro', event.x, event.y)
      entradaX.value = event.x
      // document.getElementById('ti').style.fontSize = '39px'
      // fontSize.value += 0.1
    }
    // const isActive = computed(
    //   // eslint-disable-next-line
    //   () => {
    //     const found = listObjetos.value.find(
    //       // eslint-disable-next-line
    //       element => element.id_carnet_nuevo === idElegido.value
    //     )
    //     if (found) {
    //       return true
    //     }
    //   }
    // )
    function changePosition(newRect, id) {
      // this.$store.dispatch('rect/setTop', { id: index, top: newRect.top })
      // console.log(newRect)
      const found = listObjetos.value.find(
        // eslint-disable-next-line
        element => element.id_carnet_usar === id
      )
      found.top = newRect.top
      found.left = newRect.left
      found.width = newRect.width
      found.height = newRect.height
    }
    // function activateEv(){
    //   const found = listObjetos.value.find(
    //     // eslint-disable-next-line
    //     element => element.id_carnet_nuevo === id
    //   )

    // }
    function setEstados(tieneJuvenil, tieneClasificado) {
      optionsEstados.value = []
      optionsEstados.value.push({
        text: 'Novato',
        value: 'Novato',
        disabled: false,
        selected: true,
      })
      if (tieneJuvenil === 's') {
        optionsEstados.value.push({
          text: 'Juvenil',
          value: 'Juvenil',
          disabled: false,
          selected: false,
        })
      }
      if (tieneClasificado === 's') {
        optionsEstados.value.push({
          text: 'Clasificado',
          value: 'Clasificado',
          disabled: false,
          selected: false,
        })
      }
    }
    async function changeCategoria() {
      listObjetos.value = []
      const path = `ApiConfiguration/getConfigCarnet/${categoria.value.value}/s`
      const data = await getApi(URL, path)
      // console.log(data)
      setEstados(
        categoria.value.tiene_juvenil,
        // eslint-disable-next-line
        categoria.value.tiene_clasificado
      )
      document.getElementById('divFondo').src = categoria.value.carnet_novato
      if (data.length !== 0) {
        listObjetos.value = data
        listObjetos.value.forEach(element => {
          element.top = parseInt(element.y, 10)
          element.left = parseInt(element.x, 10)
          element.width = parseInt(element.width, 10)
          element.height = parseInt(element.height, 10)
          element.sizeText = parseInt(element.sizeText, 10)
          element.id_carnet_nuevo = parseInt(element.id_carnet_nuevo, 10)
          element.id_carnet_usar = parseInt(element.id_carnet_nuevo, 10)
          element.isActive = false
        })
      } else {
        listObjetos.value = []
      }
      // console.log(listObjetos.value)
    }
    async function updateCarnet() {
      const path = 'ApiConfiguration/updateCarnet'
      const data = {
        listElementos: listObjetos.value,
        tipo: tipoJugador.value,
        fotografia: fotografia.value,
        idCategoria: categoria.value.value,
      }
      const response = await postApi(URL, path, data)
      if (response.flag === 'si') {
        file2.value = null
        fotografia.value = ''
        if (response.url !== '') {
          setearActualizadoUrl(response.url)
        }
      }
    }
    function bajarTexto() {
      // console.log('bajar')
      // document.getElementById('ti').style.fontSize = '19px'
      fontSize.value -= 0.1
    }
    return {
      resize,
      width,
      height,
      top,
      left,
      bajarTexto,
      fontSize,
      onActivated,
      desactived,
      entroEn,
      imprime,
      changePosition,
      categoria,
      changeCategoria,
      listObjetos,
      // listObjetosComputed,
      updateCarnet,
      input,
      cambiarTop,
      idElegido,
      optionsEstados,
      tipoJugador,
      file2,
      cambioFondo,
      changeTipo,
      fotografia,
      resetFotoCarnet,
    }
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.box-shadow {
  background-color: rgb(205, 205, 236, 0);
}
.titulo {
  font-family: Arial, Helvetica, sans-serif;
  color: white;
  display: flex;
  justify-content: start;
  align-items: center;
  font-size: 100%;
}
.bold {
  font-weight: bold;
}
.normal {
  font-weight: normal;
}
</style>
